export default "__VITE_ASSET__CpNRc6Ak__"